module.exports = __webpack_public_path__ + "img/1500158369.92f4e2d2.jpg";